export const DETAIL_FIELD_NAMES = {
  ticketName: '票券名稱',
  service: '服務',
  description: '優惠內容',
  terms: '使用方法',
  imageUrl: '圖片',
};
